module.exports = __webpack_public_path__ + "static/media/4.443fdb8d.png";